<template>
    <v-footer app inset padless tile style="background-color: inherit">
        <v-card outlined color="grey lighten-5" class="mx-auto my-0 py-0">
            <v-row dense>
                <v-col >
                    <a href="https://www.espa.gr/en/Pages/default.aspx/" target="_blank">
                        <v-img min-width="600px" :src="require('../assets/BANNER_MDT_ETPA2.jpg')"  aspect-ratio="13" contain alt="Visit the ESPA website"></v-img>
                    </a>
                </v-col>
            </v-row>

            <p style="text-align: center" class="ma-0 pa-0">
                <strong>©2022 — Εύδοξος</strong></p>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>